import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EditProceduresGroup, ProceduresGroup, ProceduresGroups } from 'src/app/types/procedures-group';
import { HttpService } from 'src/app/services/http/http-service.service';
import { Observable } from 'rxjs';
import { AddProceduresGroup } from 'src/app/types/procedures-group';

@Injectable({
  providedIn: 'root'
})
export class ProceduresgroupService extends HttpService {

  constructor(private http: HttpClient) {
    super('procedures-group')
  }

  add(proceduresGroup: AddProceduresGroup, proceduresIds: number[]): Observable<number> {
    return this.http.post<number>(this.url, { proceduresGroup, proceduresIds })
  }

  addProcedures(proceduresGroupId: number, proceduresIds: number[]): Observable<number> {
    return this.http.post<number>(`${this.url}/${proceduresGroupId}/relations`, { proceduresIds })
  }

  getAll(filter?): Observable<ProceduresGroups> {
    let url: string = this.url
    if (filter) {
      url += this.implementQueries(filter)
    }
    return this.http.get<ProceduresGroups>(url)
  }

  get(proceduresGroupId: number): Observable<ProceduresGroup> {
    return this.http.get<ProceduresGroup>(`${this.url}/${proceduresGroupId}`)
  }

  edit(proceduresGroupId: number, proceduresGroup: EditProceduresGroup): Observable<number> {
    return this.http.put<number>(`${this.url}/${proceduresGroupId}`, { proceduresGroup })
  }

  delete(proceduresGroupId: number): Observable<number> {
    return this.http.delete<number>(`${this.url}/${proceduresGroupId}`)
  }

  deleteProcedure(proceduresGroupId: number, procedureId: number): Observable<number> {
    return this.http.delete<number>(`${this.url}/${proceduresGroupId}/procedure/${procedureId}`)
  }

  exists(description: string): Observable<void> {
    return this.http.head<void>(`${this.url}/validate-description?description=${description}`)
  }
}
